/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
 

(function() {
    var touchingCarousel = false,
      touchStartCoords;

    document.body.addEventListener('touchstart', function(e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      }
    });

    document.body.addEventListener('touchmove', function(e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      var moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };

      if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {passive: false});
  })();
//   $('.js-toggle-pickup').on('click tap', function(){
//     var selected = $(this).hasClass('selected');
//     console.log(selected);
//     //if (!selected) setTimeout(function(){location.reload();}, 300)
//     setTimeout(function(){$('.Cart').attr('action', '/cart');}, 500)
  	
//   })
/* Store Pickup Start */  
  $('button[name="checkout"]').on('click tap', function(e){
      var selected = $('.js-toggle-pickup').hasClass('selected');
      console.log(selected)
      if (selected) {
          e.preventDefault();
          $('.Cart').attr('action', '/checkout?locale=en-pickup');
          $('.Cart').submit();    
      }
  })
  
/* Store Pickup End*/  
  
  
  $(document).ready(function(){   
    $('.sloan_address_col:nth-child(1) a').attr('target','_blank');
    $('#bloglimit_3 div.Grid__Cell:nth-child(n+4)').remove(); 
    $('#bloglimit_4 div.Grid__Cell:nth-child(n+5)').remove(); 
    $('#bloglimit_5 div.Grid__Cell:nth-child(n+6)').remove(); 
    $('#bloglimit_6 div.Grid__Cell:nth-child(n+7)').remove(); 
    
   $(".search_box .Form__Submit").click(function() {
    $(".search_box").fadeOut(); 
  });
   
   /* 
    if($(window).width() < 768 ) {
		$('.pc_show').remove();
     $('.Header__MainNav ').remove();
      
    }
    */
    

     var text_1 = $("#stock_1_div").text();
     $('#value_1_div').addClass(text_1);
    
    var text_2 = $("#stock_2_div").text();
     $('#value_2_div').addClass(text_2);
    
    var text_3 = $("#stock_3_div").text();
     $('#value_3_div').addClass(text_3);
    
    var text_4 = $("#stock_4_div").text();
     $('#value_4_div').addClass(text_4);
    
    var text_5 = $("#stock_5_div").text();
     $('#value_5_div').addClass(text_5);
    
     var text_6 = $("#stock_6_div").text();
     $('#value_6_div').addClass(text_6);
    
    var text_7 = $("#stock_7_div").text();
     $('#value_7_div').addClass(text_7);
    
    var text_8 = $("#stock_8_div").text();
     $('#value_8_div').addClass(text_8);
    
    var text_9 = $("#stock_9_div").text();
     $('#value_9_div').addClass(text_9);
    
    var text_10 = $("#stock_10_div").text();
     $('#value_10_div').addClass(text_10);
    
    var text_11 = $("#stock_11_div").text();
     $('#value_11_div').addClass(text_11);
    
    var text_12 = $("#stock_12_div").text();
     $('#value_12_div').addClass(text_12);
    
    var text_13 = $("#stock_13_div").text();
     $('#value_13_div').addClass(text_13);
    
    var text_14 = $("#stock_14_div").text();
     $('#value_14_div').addClass(text_14);
    
    var text_15 = $("#stock_15_div").text();
     $('#value_15_div').addClass(text_15);
    
    var text_16 = $("#stock_16_div").text();
     $('#value_16_div').addClass(text_16);
    
    var text_17 = $("#stock_17_div").text();
     $('#value_17_div').addClass(text_17);
    
    var text_18 = $("#stock_18_div").text();
     $('#value_18_div').addClass(text_18);
    
    var text_19 = $("#stock_19_div").text();
     $('#value_19_div').addClass(text_19);
    
    var text_20 = $("#stock_20_div").text();
     $('#value_20_div').addClass(text_20);
    
    var text_21 = $("#stock_21_div").text();
     $('#value_21_div').addClass(text_21);
    
    var text_22 = $("#stock_22_div").text();
     $('#value_22_div').addClass(text_22);
    
    var text_23 = $("#stock_23_div").text();
     $('#value_23_div').addClass(text_23);
    
    var text_24 = $("#stock_24_div").text();
     $('#value_24_div').addClass(text_24);
    
    var text_25 = $("#stock_25_div").text();
     $('#value_25_div').addClass(text_25);
    
    var text_26 = $("#stock_26_div").text();
     $('#value_26_div').addClass(text_26);
    
    var text_27 = $("#stock_27_div").text();
     $('#value_27_div').addClass(text_27);
    
    var text_28 = $("#stock_28_div").text();
     $('#value_28_div').addClass(text_28);
    
    var text_29 = $("#stock_29_div").text();
     $('#value_29_div').addClass(text_29);
  
    var text_30 = $("#stock_30_div").text();
     $('#value_30_div').addClass(text_30);
    
    
    
  });


// Removed by BOLD on July 22nd  
// $(document).ready(function(){   
//   setTimeout(function(){
//   $('.bold_option_element option:nth-child(1)').remove();
// }, 1000);	
// });



document.addEventListener('click', function (e) {
  var thumb = e.target.closest('.Product__SlideshowNavImage');
  if (!thumb) return;

  var variantValue = (thumb.getAttribute('data-variant') || '').trim();
  if (!variantValue) return; 

  var productSection = thumb.closest('[data-section-type="product"]');
  if (!productSection) return;

  var valueBtn = productSection.querySelector(
    '.OptionSelector .Popover__Value[data-value="' + CSS.escape(variantValue) + '"]'
  );

  if (valueBtn && !valueBtn.classList.contains('is-selected')) {
    valueBtn.click();
  }
});